import { render } from "./RegionsConfigsModalities.vue?vue&type=template&id=53de03c9&scoped=true"
import script from "./RegionsConfigsModalities.vue?vue&type=script&lang=js"
export * from "./RegionsConfigsModalities.vue?vue&type=script&lang=js"

import "./RegionsConfigsModalities.vue?vue&type=style&index=0&id=53de03c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53de03c9"]])

export default __exports__